// extracted by mini-css-extract-plugin
export default {"sorts":"SortingList_sorts__vzKCx"};